import { IAppInitialState } from './types';

const initialState: IAppInitialState = {
	initialized: false,
};

export default initialState;